module.exports = __webpack_public_path__ + "img/icon.1c759616.png";